module.exports = __webpack_public_path__ + "img/bras_6kl.add6f711.jpg";